/** Login gate — shown before the operator workspace. Authenticates via operator auth. */
import { useState } from 'react';

const base = '/operator/auth';

export function Login({ onAuthenticated }: { onAuthenticated: (csrfToken: string) => void }): JSX.Element {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true); setError('');
    try {
      const r = await fetch(`${base}/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Operator-Request': '1', 'X-CSRF-Token': 'login' },
        body: JSON.stringify({ username, password }),
      });
      const data = await r.json() as { csrfToken?: string; error?: string };
      if (!r.ok) throw new Error(data.error ?? `Login failed with ${r.status}`);
      if (data.csrfToken) onAuthenticated(data.csrfToken);
    } catch (e) { setError(e instanceof Error ? e.message : 'Login failed'); }
    finally { setBusy(false); }
  };

  return (
    <main style={{ maxWidth: '360px', margin: '4rem auto', padding: '2rem', border: '1px solid #344553', borderRadius: '12px', background: '#17232d' }}>
      <h1 style={{ fontSize: '1.4rem', marginTop: 0 }}>Operator console</h1>
      {error ? <div className="error" role="alert">{error}</div> : null}
      <label>Username <input value={username} disabled={busy} onChange={e => setUsername(e.target.value)} autoFocus onKeyDown={e => { if (e.key === 'Enter') void submit(); }} /></label>
      <label>Password <input value={password} disabled={busy} type="password" onChange={e => setPassword(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') void submit(); }} /></label>
      <button disabled={busy || !username.trim() || !password} onClick={() => void submit()}>Log in</button>
    </main>
  );
}